import React, { useState, useEffect } from 'react';
import './App.css';
import menuData from './menuData.json';
export default function App() {


  const [cart, setCart] = useState({});
  const [showCheckout, setShowCheckout] = useState(false);
  const [name, setName] = useState('');
  const [table, setTable] = useState('');
  const [expandedCategory, setExpandedCategory] = useState(null);
  const [dineType, setDineType] = useState('dine');
  const [cartPulse, setCartPulse] = useState(false);
  const [instructions, setInstructions] = useState('');
  const [isJain, setIsJain] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
const [selectedVariants, setSelectedVariants] = useState(() => {
  const defaults = {};
  // Initialize with first variant for each item that has variants
  Object.values(menuData.items).forEach(categoryItems => {
    categoryItems.forEach(item => {
      if (item.variants && item.variants.length > 0) {
        defaults[item.name] = item.variants[0].type;
      }
    });
  });
  return defaults;
});
  const [searchResults, setSearchResults] = useState([]);
  const [showAllCategories, setShowAllCategories] = useState(true);

  // Handle search functionality
  useEffect(() => {
    if (searchQuery.trim() === '') {
      setSearchResults([]);
      setShowAllCategories(true);
      return;
    }

    const results = [];
    Object.keys(menuData.items).forEach(category => {
      menuData.items[category].forEach(item => {
        if (item.name.toLowerCase().includes(searchQuery.toLowerCase())) {
          results.push({
            ...item,
            category
          });
        }
      });
    });

    setSearchResults(results);
    setShowAllCategories(false);
  }, [searchQuery]);

  // Handle scroll to show search bar - only when not in checkout
  useEffect(() => {
    if (showCheckout) return;

    const handleScroll = () => {
      if (window.scrollY > 50) {
        setShowSearch(true);
      } else {
        setShowSearch(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [showCheckout]);

  // Cart functions
  const addToCart = (item, variantType = 'Regular') => {
    const price = item.variants ? 
      item.variants.find(v => v.type === variantType).price : 
      item.price;
    
    const key = item.variants ? 
      `${item.name} - ${variantType}` : 
      item.name;

    setCart(prev => ({
      ...prev,
      [key]: {
        ...item,
        price,
        quantity: prev[key] ? prev[key].quantity + 1 : 1,
        variantType: item.variants ? variantType : null
      }
    }));
    setCartPulse(true);
    setTimeout(() => setCartPulse(false), 300);
  };

  const removeFromCart = (itemKey) => {
    setCart(prev => {
      if (!prev[itemKey]) return prev;
      const qty = prev[itemKey].quantity - 1;
      if (qty <= 0) {
        const { [itemKey]: _, ...rest } = prev;
        return rest;
      }
      return {
        ...prev,
        [itemKey]: {
          ...prev[itemKey],
          quantity: qty
        }
      };
    });
  };

  const totalAmount = Object.values(cart).reduce(
    (sum, item) => sum + item.price * item.quantity, 0
  );

  // Order handling
  const handleOrder = () => {
    if (!name || (!table && dineType === 'dine')) {
      alert('Please fill all mandatory fields.');
      return;
    }

    const orderTime = new Date().toLocaleString();
    const orderDetails = Object.values(cart)
      .map(item => `${item.name}${item.variantType ? ` (${item.variantType})` : ''} x${item.quantity} = ₹${item.price * item.quantity}`)
      .join('\n');

    const specialRequests = [
      isJain && '🟢 JAIN ORDER',
      instructions && `📝 Cooking Instructions: ${instructions}`
    ].filter(Boolean).join('\n');

    const text = `*New Order*\n\nName: *${name}*\nTable: *${dineType === 'dine' ? table : 'Takeaway'}*\nTime: ${orderTime}\n\n${orderDetails}\n\n${specialRequests}\n*Total*: ₹${totalAmount}`;
    const encoded = encodeURIComponent(text);
    window.open(`https://wa.me/918141953822?text=${encoded}`, '_self');
    
    // Reset form
    setCart({});
    setName('');
    setTable('');
    setShowCheckout(false);
    setInstructions('');
    setIsJain(false);
  };

  // UI helpers
  const toggleCategory = (category) => {
    setExpandedCategory(expandedCategory === category ? null : category);
  };

  const handleVariantChange = (itemName, variantType) => {
    setSelectedVariants(prev => ({
      ...prev,
      [itemName]: variantType
    }));
  };

  const renderItemCard = (item, category) => {
    const itemKey = item.variants ? 
      `${item.name} - ${selectedVariants[item.name] || 'Regular'}` : 
      item.name;
      
    return (
      <div key={item.name} className="item-card">
        <div className="item-info">
          <div className="item-name">{item.name}</div>
          {item.variants ? (
            <div className="variant-selector">
              <select
                onChange={(e) => handleVariantChange(item.name, e.target.value)}
                className="variant-dropdown"
                value={selectedVariants[item.name] || 'Regular'}
              >
                {item.variants.map(variant => (
                  <option key={variant.type} value={variant.type}>
                    {variant.type} - ₹{variant.price}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <div className="item-price">₹{item.price}</div>
          )}
        </div>
        <div className="item-actions">
          <button 
            className="quantity-btn minus"
            onClick={() => removeFromCart(itemKey)}
            disabled={!cart[itemKey]}
          >
            -
          </button>
          <div className="item-quantity">{cart[itemKey]?.quantity || 0}</div>
          <button 
            className="quantity-btn plus"
            onClick={() => addToCart(
              item, 
              item.variants ? (selectedVariants[item.name] || 'Regular') : null
            )}
          >
            +
          </button>
        </div>
      </div>
    );
  };

  return (
   
    <div className="app-container">
      <div className="fixed-logo">
        <img src='Kafenity Logo CQ x7 6-1-2024.png' alt="Logo" />
      </div>
      {/* Header with search - only show when not in checkout */}
      {!showCheckout && (
        <div className={`app-header`}>
          <div className="header-content">
            {!showSearch && searchQuery === '' ? (
              <>
                <img src="./logo1.png" alt="Restaurant Logo" className="header-logo" />
                <h1>Kafenity</h1>
              </>
            ) : (
              <div className="search-container">
                  <span className="search-icon">🔍</span>
                <input
                  type="text"
                  placeholder="Search menu items..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="search-input"
                />
                {searchQuery && (
                  <button 
                    className="clear-search"
                    onClick={() => {
                      setSearchQuery('');
                      setShowSearch(false);
                    }}
                  >
                    
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      {/* Main content area */}
      {!showCheckout ? (
        <div className="menu-container">
          {/* Search results view */}
          {searchQuery && searchResults.length > 0 && !showAllCategories ? (
            <div className="search-results-container">
              <h3>Search Results</h3>
              <div className="items-grid">
                {searchResults.map(item => renderItemCard(item, item.category))}
              </div>
              <button 
                className="show-all-btn"
                onClick={() => {
                  setSearchQuery('');
                  setShowAllCategories(true);
                }}
              >
                Show All Categories
              </button>
            </div>
          ) : (
            /* Normal categories view */
            menuData.categories.map(category => (
              <div key={category.name} className="category-container">
                <div
                  onClick={() => toggleCategory(category.name)}
                  className={`category-header ${expandedCategory === category.name ? 'expanded' : ''}`}
                >
                  {category.name}
                  <span className="category-icon">
                    {expandedCategory === category.name ? '▲' : '▼'}
                  </span>
                </div>

                <div className={`category-content ${expandedCategory === category.name ? 'open' : ''}`}>
                  <div className="items-grid">
                    {menuData.items[category.name]?.map(item => (
                      renderItemCard(item, category.name)
                    ))}
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      ) : (
        /* Checkout view */
        <div className="checkout-container">
          <div className="checkout-header">
            <button 
              className="back-button"
              onClick={() => setShowCheckout(false)}
            >
              &larr; Back to Menu
            </button>
            <br/>
            <h2>Your Order</h2>
          </div>

          <div className="cart-items">
            {Object.values(cart).length > 0 ? (
              Object.values(cart).map(item => (
                <div key={item.name + (item.variantType || '')} className="cart-item">
                  <div className="cart-item-info">
                    <div className="cart-item-name">
                      {item.name}{item.variantType && ` (${item.variantType})`}
                    </div>
                    <div className="cart-item-price">
                      ₹{item.price} × {item.quantity} = ₹{item.price * item.quantity}
                    </div>
                  </div>
                  <div className="cart-item-actions">
                    <button 
                      className="cart-btn minus"
                      onClick={() => removeFromCart(
                        item.variantType ? 
                          `${item.name} - ${item.variantType}` : 
                          item.name
                      )}
                    >
                      -
                    </button>
                    <button 
                      className="cart-btn plus"
                      onClick={() => addToCart(item, item.variantType || item.variants?.[0])}
                    >
                      +
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="empty-cart">
                <div className="empty-icon">🛒</div>
                <p>Your cart is empty</p>
                <button 
                  className="browse-btn"
                  onClick={() => setShowCheckout(false)}
                >
                  Browse Menu
                </button>
              </div>
            )}
          </div>

          {Object.values(cart).length > 0 && (
            <>
              <div className="checkout-form">
                <div className="form-group">
                  <label>Name*</label>
                  <input 
                    type="text" 
                    value={name} 
                    onChange={(e) => setName(e.target.value)}
                    className="form-input"
                    required 
                  />
                </div>

                <div className="form-group">
                  <label>Order Type</label>
                  <div className="order-type">
                    <button
                      className={`type-btn ${dineType === 'dine' ? 'active' : ''}`}
                      onClick={() => setDineType('dine')}
                    >
                      Dine In
                    </button>
                    <button
                      className={`type-btn ${dineType === 'takeaway' ? 'active' : ''}`}
                      onClick={() => setDineType('takeaway')}
                    >
                      Takeaway
                    </button>
                  </div>
                </div>

                {dineType === 'dine' && (
                  <div className="form-group">
                    <label>Table No*</label>
                    <input 
                      type="text" 
                      value={table} 
                      onChange={(e) => setTable(e.target.value)}
                      className="form-input"
                      required 
                    />
                  </div>
                )}

                <div className="form-group">
                  <label>Cooking Instructions</label>
                  <textarea
                    value={instructions}
                    onChange={(e) => setInstructions(e.target.value)}
                    className="form-input"
                    placeholder="Any special instructions..."
                    rows="3"
                  />
                </div>

                <div className="form-group toggle-group">
                  <label>Jain Preparation</label>
                  <div 
                    className={`jain-toggle ${isJain ? 'active' : ''}`}
                    onClick={() => setIsJain(!isJain)}
                  >
                    <div className="toggle-slider"></div>
                    <span className="toggle-text">{isJain ? 'ON' : 'OFF'}</span>
                  </div>
                </div>
              </div>

              <div className="order-summary">
                <div className="total-row">
                  <span>Total:</span>
                  <span className="total-amount">₹{totalAmount}</span>
                </div>
                <button 
                  className="order-button"
                  onClick={handleOrder}
                >
                  ✅ Place Order via WhatsApp
                </button>
              </div>
            </>
          )}
        </div>
      )}

      {/* Floating cart button */}
      {!showCheckout && totalAmount > 0 && (
        <div 
          className={`cart-button ${cartPulse ? 'pulse' : ''}`}
          onClick={() => setShowCheckout(true)}
        >
          <div className="cart-icon">🛒</div>
          <div className="cart-text">Order Now</div>
          <div className="cart-total">₹{totalAmount}</div>
        </div>
      )}
    </div>
  );
}